module.exports = __webpack_public_path__ + "static/media/ico_tint_alt_03.ee6f8d4f.svg";